module.exports = __webpack_public_path__ + "static/media/justrawr.38cea34a.png";